import * as React from "react";
const SvgBattery = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 4.686v14.628h17.914v-3.283h2.344V7.97h-2.344V4.686h-8.957zM3.38 6.19h14.9v3.274H20.621v5.07H18.28v3.274H3.38V12Zm1.307 1.307v9.004H16.973V7.498h-6.145zM6.19 9.004h9.274v5.992H6.19V12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgBattery;
